export default __webpack_public_path__ + "static/logo-14cd2c8cb6a032f56297cc54f5d0f4b8.png";